
const filmDetailRegex = /\/film\/.+/;
export const isFilmDetailPathname = (pathname) => {
    return filmDetailRegex.test(pathname);
}
